import type {
  PiiLookupAddressDto,
  PiiLookupSubjectDto,
  PiiPostalAddressDto,
} from "@babackapp/private-api-client/generated/schema";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@babackapp/ui/components/card";

const SUBJECT_FIELDS: { key: keyof PiiLookupSubjectDto; label: string }[] = [
  { key: "subjectId", label: "subjectId" },
  { key: "email", label: "Email" },
  { key: "shopifyCustomerId", label: "Client Shopify" },
  { key: "firstName", label: "Prénom" },
  { key: "lastName", label: "Nom" },
  { key: "phone", label: "Téléphone" },
  { key: "locale", label: "Langue" },
];

export const formatAddress = (address: PiiPostalAddressDto): string =>
  [
    [address.firstName, address.lastName].filter(Boolean).join(" "),
    address.company,
    address.line1,
    address.line2,
    [address.zip, address.city].filter(Boolean).join(" "),
    address.countryCode,
    address.phone,
  ]
    .filter(Boolean)
    .join(", ");

export function PiiSubjectCard({
  subject,
  addresses,
}: {
  subject: PiiLookupSubjectDto | null;
  addresses: PiiLookupAddressDto[];
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Coffre</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-sm">
        {subject ? (
          <dl className="grid grid-cols-[10rem_1fr] gap-x-4 gap-y-1">
            {SUBJECT_FIELDS.map(({ key, label }) => (
              <div key={key} className="contents">
                <dt className="text-muted-foreground">{label}</dt>
                <dd className="font-mono break-all">{subject[key] ?? "-"}</dd>
              </div>
            ))}
          </dl>
        ) : (
          <p className="text-muted-foreground">
            Aucun sujet pour cet email dans le coffre.
          </p>
        )}
        <div>
          <p className="font-medium mb-1">Adresses ({addresses.length})</p>
          <ul className="space-y-1">
            {addresses.map(({ ref, address, documentCount }) => (
              <li key={ref} className="flex justify-between gap-4">
                <span>{formatAddress(address)}</span>
                <span className="text-muted-foreground whitespace-nowrap">
                  {documentCount} document(s)
                </span>
              </li>
            ))}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
}
